import React from 'react';
import { Link } from '@tanstack/react-router';
import { Card, CardContent } from '@/components/ui/card';
import { Logo } from '@/components/Logo';

export const Register: React.FC = () => {
  // Registration is disabled
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <Logo />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white">Registration Unavailable</h2>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            New registrations are currently disabled. Please contact your administrator.
          </p>
        </div>

        <Card className="border-gray-200 dark:border-gray-700">
          <CardContent className="text-center py-8">
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              Registration is currently disabled.
            </p>
            <Link
              to="/login"
              className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              Go to Login
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};